export const APP_NAME = 'Textotals';
export const APP_HELP_EMAIL = 'textotals@strongwares.com';
export const APP_SHORT_DESCR = 'Action Accounts Totals';
export const REGISTER_BUTTON_TEXT = 'Add New User';
export const UNREGISTER_BUTTON_TEXT = 'Remove User';
export const LOGIN_BUTTON_TEXT = 'Login';
export const PREMIUM_BUTTON_TEXT = 'Premium';
